import dayjs from 'dayjs';
import localeData from 'dayjs/plugin/localeData';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import 'dayjs/locale/en-au';

export function configureDayjs() {
  dayjs.extend(localeData);
  dayjs.extend(weekOfYear);
  dayjs.locale('en-au');
}
